<template>
    <v-text-field 
        ref="field" 
        :label="label" 
        :value="valueString"
        :rules="rules" 
        :prefix="prefix"
        :suffix="suffix"
        :disabled="disabled"
        @change="$emit('change', makeNumber($event))"
    />
</template>

<script>
import AutoNumeric from "autonumeric";

export default {
    name: "NumericEntry",
    model: {
        prop: "value",
        event: "change",
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        label: String,
        maxValue: {
            type: Number,
            default: 100
        }, 
        minValue: {
            type: Number,
            default: 0
        }, 
        decimalPlaces: {
            type: Number,
            default: 2
        },
        disabled: Boolean,
        // eslint-disable-next-line vue/require-default-prop
        value: [String, Number],
        // eslint-disable-next-line vue/require-default-prop
        rules: Array,
        prefix: {
            type: String,
            default: ""
        },
        suffix: {
            type: String,
            default: ""
        }
    },
    computed: {
        valueString: function() {
            return this.value ? this.value.toString() : "";
        }
    },
    watch: {
        value: {
            handler() {
                this.controlReference.set(this.value);
            },
            deep: true
        }
    },
    methods: {
        makeNumber(x) {
            // remove all commas from string before turning it into a number
            return parseFloat(x.replace(/,/g, ''));
        }
    },
    mounted() {
        this.controlReference = new AutoNumeric(this.$refs.field.$refs.input).update({
            decimalPlaces: this.decimalPlaces,
            maximumValue: this.maxValue,
            minimumValue: this.minValue
        });
    },
    data: () => {
        return {
            controlReference: null
        };
    }
};
</script>
